<mat-tab-group>
    <mat-tab label="Rollen">
        @if (roles()?.length && functionalities()?.length) {
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th class="feature feature-name">
                            <b>Key</b>
                        </th>
                        @for (role of roles(); track role) {
                            <th>
                                <div class="role-name">
                                    {{role.name}}
                                </div>
                            </th>
                        }
                        <th class="after">
                        </th>
                    </tr>
                </thead>
                @for (functionality of functionalities(); track functionality) {
                    <tr>
                        <th class="feature feature-side">
                            {{functionality.name}}
                        </th>
                        @for (role of roles(); track role) {
                            <td class="checkox-td" title="{{role.name}}">
                                <input
                                    (change)="checkFunctionality($event, functionality, role)"
                                    [checked]="role | roleHasFunctionality : functionality"
                                    [disabled]="disabled"
                                    type="checkbox"/>
                            </td>
                        }
                        <th class="after">
                            {{functionality.key}}
                        </th>
                    </tr>
                }
            </table>
        }
    </mat-tab>
    <mat-tab label="Functionaliteiten">
        @if (functionalities()?.length && features()?.length) {
            <table class="table table-hover">
                <thead>
                    <tr>
                        <th class="feature feature-name">
                            <b>Key</b>
                        </th>
                        @for (functionality of functionalities(); track functionality) {
                            <th>
                                <div class="role-name">
                                    {{functionality.name}}
                                </div>
                            </th>
                        }
                        <th class="after">
                        </th>
                    </tr>
                </thead>
                @for (feature of features(); track feature) {
                    <tr>
                        <th class="feature feature-side">
                            {{feature.name}}
                        </th>
                        @for (functionality of functionalities(); track functionality) {
                            <td class="checkox-td" title="{{functionality.name}}">
                                <input
                                    (change)="checkFeature($event, functionality, feature)"
                                    [checked]="functionality | functionalityHasFeature : feature"
                                    [disabled]="disabled"
                                    type="checkbox"/>
                            </td>
                        }
                        <th class="after">
                            {{feature.key}}
                        </th>
                    </tr>
                }
            </table>
        }
    </mat-tab>
</mat-tab-group>
